const admin = [
  {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "adminPage" */ '@/components/modules/admin/index'), // AdminPage,
    meta: {
      title: 'Admin',
      requiresAuth: true,
    },
  },
];

export default admin;
